<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="企业品牌">
                <a-select
                  show-search
                  v-model="queryParam.tenantId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="6" :sm="24">
              <a-form-item label="区域名称">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.name" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template>
              <a-col :md="6" :sm="24">
                <a-form-item label="联系电话">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.mobile" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="12" :sm="24">
                <a-form-item label="省市区">
                  <v-distpicker
                    :province="queryParam.province"
                    :city="queryParam.city"
                    :area="queryParam.area"
                    @province="onChangeProvince"
                    @city="onChangeCity"
                    @area="onChangeArea"
                  >
                  </v-distpicker>
                </a-form-item>
              </a-col>
            </template>
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="省">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.province" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template> -->
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="市">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.city" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template> -->
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="区">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.area" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template> -->
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker
                    v-model="value"
                    format="YYYY-MM-DD"
                    :placeholder="['开始时间', '结束时间']"
                    @change="onChange"
                  />
                </a-form-item>
              </a-col>
            </template>
            <!-- <a-col :md="6" :sm="24">
              <a-form-item label="设备编号">
                <a-input v-model="queryParam.devCode" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col> -->
            <!-- <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户编码">
                  <a-input v-model="queryParam.code" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="信用代码">
                  <a-input v-model="queryParam.socialCreditCode" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="联系人">
                  <a-input v-model="queryParam.contacts" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="电话">
                  <a-input v-model="queryParam.mobile" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="状态">
                  <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 正常 </a-select-option>
                    <a-select-option :value="1"> 异常关闭 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="租户类型">
                  <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                    <a-select-option :value="1"> 厂商 </a-select-option>
                    <a-select-option :value="2"> 经销商 </a-select-option>
                    <a-select-option :value="3"> 分经销商 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="营业状态">
                  <a-select placeholder="请选择" v-model="queryParam.tradeStatus" style="width: 100%" allow-clear>
                    <a-select-option :value="0"> 营业中 </a-select-option>
                    <a-select-option :value="10"> 维修升级中 </a-select-option>
                    <a-select-option :value="60"> 暂停营业 </a-select-option>
                    <a-select-option :value="70"> 隐藏 </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="省">
                  <a-input v-model="queryParam.province" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="市">
                  <a-input v-model="queryParam.city" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="区">
                  <a-input v-model="queryParam.area" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="时间范围">
                  <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onChange" />
                </a-form-item>
              </a-col>
            </template> -->
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button
            :loading="loadingAdd"
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['system:region:list']"
          >
            <a-icon type="plus" />新增
          </a-button>
          <!-- <a-button
            type="primary"
            :disabled="single"
            @click="$refs.createForm.handleUpdate(undefined, ids)"
            v-hasPermi="['system:region:edit']"
          >
            <a-icon type="edit" />修改
          </a-button>
          <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['system:region:remove']">
            <a-icon type="delete" />删除
          </a-button> -->
          <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['abm-fix:dev:export']">
          <a-icon type="download" />导出
        </a-button> -->
        </template>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
        @okDate="handleDate"
        @close="loadingAdd = false"
      />
      <!-- 详情 -->
      <reginDetail ref="reginDetail"></reginDetail>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
      >
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="tenantCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:jing:three')">
          <a-button type="link" size="large">
            {{ record.tenantCount }}
          </a-button>
        </span>
        <span slot="devCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:she:three')">
          <a-button type="link" size="large">
            {{ record.devCount }}
          </a-button>
        </span>
        <span slot="examinerCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:she:three')">
          <a-button type="link" size="large">
            {{ record.examinerCount }}
          </a-button>
        </span>
        <span slot="waterCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:she:three')">
          <a-button type="link" size="large">
            {{ record.waterCount }}
          </a-button>
        </span>
        <span slot="orderCount" slot-scope="text, record" @click="handleLook(record, 3, 'system:ding:three')">
          <a-button type="link" size="large">
            {{ record.orderCount }}
          </a-button>
        </span>
        <span slot="address" slot-scope="text, record">
          <a-tooltip :title="`${record.province} ${record.city} ${record.area} ${record.address}`">
            <!-- <span class="ellipsis-text">{{ text }}</span> -->
            {{ record.province }} {{ record.city }} {{ record.area }} {{ record.address }}
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['system:region:edit']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['system:region:remove']" />
          <a-dropdown v-hasPermi="['system:region:query', 'system:region:remov']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['system:tenant:query']">
                <a v-hasPermi="['system:region:query']" @click="$refs.reginDetail.init(record, 1)"> 详情 </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['system:tenant:query']">
                <a @click="handleDelete(record)" v-hasPermi="['system:region:remove']"> 删除 </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>
<script>
import { fetchList, delObj } from '@/api/pressure/region'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'
import reginDetail from './modules/reginDetail.vue'
import moment from 'moment'
export default {
  name: 'Post',
  components: {
    CreateForm,
    reginDetail,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      loadingAdd: false,
      selectedRowKeys: [],
      selectedRows: [],
      value: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      userList: [],
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '区域名称',
          dataIndex: 'name',
          width: 100,
          align: 'center',
          fixed: 'left',
          ellipsis: true,
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
          width: 120,
          align: 'center',
        },
        {
          title: '联系人',
          dataIndex: 'contacts',
          ellipsis: true,
          width: 80,
          align: 'center',
        },
        {
          title: '企业品牌',
          dataIndex: 'tenantName',
          ellipsis: true,
          width: 100,
          align: 'center',
        },
        {
          title: '经销商',
          dataIndex: 'tenantCount',
          width: 70,
          scopedSlots: { customRender: 'tenantCount' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '设备',
          dataIndex: 'devCount',
          width: 70,
          scopedSlots: { customRender: 'devCount' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '验收员',
          dataIndex: 'examinerCount',
          width: 80,
          scopedSlots: { customRender: 'examinerCount' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '水工',
          dataIndex: 'waterCount',
          width: 70,
          scopedSlots: { customRender: 'waterCount' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '订单	',
          dataIndex: 'orderCount',
          width: 60,
          scopedSlots: { customRender: 'orderCount' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '详细地址',
          dataIndex: 'address',
          scopedSlots: { customRender: 'address' },
          // ellipsis: true,
          width: 170,
          align: 'center',
        },
        // {
        //   title: '设备编号',
        //   dataIndex: 'devCode',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '租户简称',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
        // {
        //   title: '租户编码',
        //   dataIndex: 'code',
        //   align: 'center',
        // },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 90,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 130,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    if (!this.isOperate) {
      this.columns.pop()
    }
    if (this.userType === 0) {
      this.getQi()
    } else {
      this.columns.splice(3, 1)
    }
    this.queryParam.tenantId = this.tenantId
    this.getList()
  },
  computed: {
    hasPermission() {
      return (permission) => {
        console.log(this.userType, '测试type====')
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // 查询企业品牌
    getQi() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 1,
        status: 0,
      }
      listTenant(query).then((res) => {
        console.log(res, '的点点滴滴')
        this.userList = res.data.records
      })
    },
    handleDate() {
      this.$emit('changeBack')
    },
    // 点击展示不同的页面信息
    handleLook(e, index, name) {
      if (!this.hasPermission(name)) return this.$message.error('暂无权限查看')
      this.$nextTick(() => {
        this.$refs.reginDetail.init(e, index)
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
      if (e.length) {
        this.queryParam.createBeginTime = moment(e[0]).format('YYYY-MM-DD') + ' ' + '00:00:00'
        this.queryParam.createEndTime = moment(e[1]).format('YYYY-MM-DD') + ' ' + '23:59:59'
      } else {
        this.queryParam.createBeginTime = ''
        this.queryParam.createEndTime = ''
      }
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
      this.loadingAdd = false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    // 选择省
    onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.queryParam.province = e.value
      } else {
        this.queryParam.province = ''
      }
    },
    // 选择市
    onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
      }
    },
    // 选择区
    onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`,
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
